import { c as _c } from "react/compiler-runtime";
import type { MeasuredKeyRequirements } from '@/lib/piano/touch-design/measured-key.requirements';
import { useCallback } from 'react';
import { useGlobalMeasures } from '../store/use-measure-store';
import { useMeasureOptions } from '../store/use-measure-options-store';
export const useKeyMeasurementsHelpers = () => {
  const $ = _c(6);
  const {
    useManualSWRMeasurements,
    useSupportSpringMeasurements
  } = useMeasureOptions();
  const globalMeasure = useGlobalMeasures();
  let t0;
  if ($[0] !== globalMeasure || $[1] !== useManualSWRMeasurements || $[2] !== useSupportSpringMeasurements) {
    t0 = keyMeasure => {
      const wippenRadiusWeight = keyMeasure.wippenRadiusWeight ?? globalMeasure.wippenRadiusWeight;
      const keyWeightRatio = keyMeasure.keyWeightRatio ?? globalMeasure.keyWeightRatio;
      return {
        ...keyMeasure,
        downWeightWithSpringSupport: useSupportSpringMeasurements ? keyMeasure.downWeightWithSpringSupport : null,
        keyWeightRatio,
        measuredStrikeWeightRatio: useManualSWRMeasurements ? keyMeasure.measuredStrikeWeightRatio : null,
        wippenRadiusWeight
      };
    };
    $[0] = globalMeasure;
    $[1] = useManualSWRMeasurements;
    $[2] = useSupportSpringMeasurements;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const computeKeyMeasurements = t0;
  let t1;
  if ($[4] !== computeKeyMeasurements) {
    t1 = {
      computeKeyMeasurements
    };
    $[4] = computeKeyMeasurements;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};